import { Routes, Route } from 'react-router'
import Layout from './components/Layout'
import Home from './pages/Home'
import ViolenciaContraPessoasLGBTI from './pages/ViolenciaContraPessoasLGBTI'
import ConsequenciaImpacto from './pages/ConsequenciaImpacto'
import ApoioAPAV from './pages/ApoioAPAV'
import Direitos from './pages/Direitos'
import InfoUteis from './pages/InfoUteis'
import NotFound from './pages/NotFound'

function App() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/ViolenciaContraPessoasLGBTI" element={<ViolenciaContraPessoasLGBTI />} />
                <Route path="/ConsequenciaImpacto" element={<ConsequenciaImpacto />} />
                <Route path="/ApoioAPAV" element={<ApoioAPAV />} />
                <Route path="/Direitos" element={<Direitos />} />
                <Route path="/infoUteis" element={<InfoUteis />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Layout>
    )
}

export default App
